@for (conversation of conversations; track conversation.id) {
<div class="p-3 cursor-pointer border-round-xl hover:surface-100 flex align-items-center justify-content-between"
    [ngClass]="{ 'bg-primary-100': conversation.id === selectedConversation?.id }"
    (click)="selectConversation(conversation)">
    <div class="conversation-name" [ngClass]="{ 'font-bold': !conversation.new && !conversation.hasStatus(Status.Read)} ">{{ conversation.title }}</div>
    <div class="flex align-items-center gap-2">
        @if (!conversation.private && conversation.hasStatus(Status.Followed)) {
        <i class="fa-solid fa-bell text-500" style="font-size: .75rem" pTooltip="Vous suivez cette conversation"
            tooltipPosition="left"></i>
        }
        @if (!conversation.new && !conversation.hasStatus(Status.Read)) {
        <i class="fa-solid fa-circle text-primary" style="font-size: .75rem"></i>
        }
    </div>
</div>
}